import { cn } from "@/lib/utils"

export type StatusTone = "success" | "warning" | "danger" | "info" | "transit" | "sleeper" | "neutral"

// Domain → tone map. Keep keys lowercase/snake to match API enums.
export const STATUS_TONE: Record<string, StatusTone> = {
  // Load
  booked: "info", in_transit: "transit", delivered: "success", delayed: "warning",
  // Driver HOS
  on_duty: "info", driving: "success", off_duty: "neutral", sleeper: "sleeper",
  // Truck
  active: "success", maintenance: "warning", out_of_service: "danger",
  // Invoice
  paid: "success", pending: "neutral", overdue: "danger",
}

const toneClass: Record<StatusTone, string> = {
  success: "bg-status-success-bg text-status-success-fg border-status-success-border",
  warning: "bg-status-warning-bg text-status-warning-fg border-status-warning-border",
  danger: "bg-status-danger-bg text-status-danger-fg border-status-danger-border",
  info: "bg-status-info-bg text-status-info-fg border-status-info-border",
  transit: "bg-status-transit-bg text-status-transit-fg border-status-transit-border",
  sleeper: "bg-status-sleeper-bg text-status-sleeper-fg border-status-sleeper-border",
  neutral: "bg-status-neutral-bg text-status-neutral-fg border-status-neutral-border",
}
const dotClass: Record<StatusTone, string> = {
  success: "bg-status-success-dot", warning: "bg-status-warning-dot", danger: "bg-status-danger-dot",
  info: "bg-status-info-dot", transit: "bg-status-transit-dot", sleeper: "bg-status-sleeper-dot", neutral: "bg-status-neutral-dot",
}

export function StatusBadge({ status, tone, children, size = "default", dot = true, className, ...props }: {
  status?: string; tone?: StatusTone; size?: "sm" | "default"; dot?: boolean
} & React.ComponentProps<"span">) {
  const t = tone ?? STATUS_TONE[status ?? ""] ?? "neutral"
  return (
    <span {...props} className={cn(
      "inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap",
      size === "sm" ? "h-5 px-2 text-[11px]" : "h-6 px-2.5 text-xs",
      toneClass[t], className)}>
      {dot && <span className={cn("size-1.5 rounded-full", dotClass[t])} />}
      {children}
    </span>
  )
}
